var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTableSortIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 14.667h4c3.334 0 4.667-1.333 4.667-4.666V6c0-3.334-1.333-4.667-4.667-4.667H6c-3.333 0-4.666 1.333-4.666 4.667v4c0 3.333 1.333 4.666 4.666 4.666M6.79 11.433 4.763 9.406M6.79 4.566v6.867M9.216 4.566l2.027 2.027M9.216 11.433V4.566"
})));
export { SvgTableSortIcon as ReactComponent };
export default __webpack_public_path__ + "0fd4b2e1ea27c0eb34e5985b90d91454.svg";